export const getInputFocus = state => {
  var _state$widgetInputFoc;
  return (_state$widgetInputFoc = state.widgetInputFocusStatus) === null || _state$widgetInputFoc === void 0 ? void 0 : _state$widgetInputFoc.widgetInputIsOnFocus;
};